import { useQuery } from '@tanstack/react-query';
import { fetchCurrentTerms } from '@/api/content.api';

export const TERMS_QUERY_KEY = ['content', 'terms'] as const;

/**
 * Fetches the currently-published Terms & Conditions for `TermsModal`
 * (MYN-33). `enabled` defaults to true but callers that only need the
 * content once a dialog is opened (rather than on mount) should pass the
 * dialog's own `open` state through.
 */
export function useTermsContent(enabled = true) {
  return useQuery({
    queryKey: TERMS_QUERY_KEY,
    queryFn: fetchCurrentTerms,
    enabled,
  });
}
